import { Button, Form, Input } from "antd";
import React, { useState } from "react";
import { Images } from "../../Assets/Index";
import { userSignup } from "../../ApiServices/Apifun";
import { NavLink, useNavigate } from "react-router-dom";
import { dispatchtoast, setLocalStorageItem } from "../../Utils";
import { BiLockAlt, BiMobile, BiUser } from "react-icons/bi";
import { FaCheckCircle } from "react-icons/fa";

const Registration = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [mobile, setMobile] = useState("");
  const isValidPhone = /^\d{10}$/.test(mobile);

  const handleSubmit = (val) => {
    setLoading(true);
    const payload = {
      name: val.name,
      mobile: val.mobile,
      password: val.password,
      confirm_password: val.confirm_password,
    };

    userSignup(payload)
      .then((res) => {
        if (res.status) {
          dispatchtoast(res.message || "Signup successful");
          // Signup auto-logs the user in
          setLocalStorageItem("isLoggedIn", true);
          setLocalStorageItem("accessToken", res.access_token);
          setLocalStorageItem("user", res?.user);
          setLocalStorageItem("is_new_user", res?.is_new_user);
          navigate("/allGame");
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  };

  return (
    <div className="flex h-screen justify-center items-center">
      <div className="flex h-screen justify-center items-left">
        <div className="flex relative shadow-lg mx-8 bg-black shadow-red-500 rounded-lg justify-center  items-center flex-col px-10 md:px-18 py-20">
          <img src={Images.Logo} className="w-[300px] " alt="Chandni Chowk Matka" />
          <div className="text-start">
            <p className="mt-2 text-white text-2xl font-normal custome">
              Create Account
            </p>
            <p className="mt-2 text-white font-thin custome">
              It's easy to start playing on Chandni Chowk Matka. Enter your
            </p>

            <p className=" text-white font-thin custome">
              details below to sign up and continue.
            </p>
          </div>

          <div className="mt-12 w-full">
            <Form
              form={form}
              onFinish={(val) => handleSubmit(val)}
              onFinishFailed={(err) => console.log(err)}
            >
              <Form.Item
                name={"name"}
                className="m-0"
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Please enter your name",
                  },
                ]}
              >
                <Input
                  prefix={
                    <BiUser className="text-gray-400 font-bold text-2xl" />
                  }
                  className="custom-placeholder bg-black text-white hover:bg-black shadow-sm shadow-[#a6a6a6] rounded-2xl border-none"
                  placeholder="Full Name"
                />
              </Form.Item>

              <Form.Item
                name={"mobile"}
                className="mt-4"
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Please enter mobile number",
                  },
                  {
                    pattern: /^\d{10}$/,
                    message: "Enter a valid 10 digit mobile number",
                  },
                ]}
              >
                <Input
                  prefix={
                    <BiMobile className="text-gray-400 font-bold text-2xl" />
                  }
                  suffix={
                    isValidPhone && (
                      <FaCheckCircle className="text-red-600 text-xl" />
                    )
                  }
                  className="custom-placeholder bg-black text-white hover:bg-black shadow-sm shadow-[#a6a6a6] rounded-2xl border-none"
                  placeholder="Mobile Number"
                  onChange={(e) => setMobile(e.target.value)}
                  value={mobile}
                  maxLength={10}
                />
              </Form.Item>

              <Form.Item
                name={"password"}
                className="mt-4"
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Please enter a password",
                  },
                  {
                    min: 6,
                    message: "Password must be at least 6 characters",
                  },
                ]}
              >
                <Input.Password
                  prefix={
                    <BiLockAlt className="text-gray-400 font-bold text-2xl" />
                  }
                  className="custom-placeholder bg-black text-white hover:bg-black shadow-sm shadow-[#a6a6a6] rounded-2xl border-none"
                  placeholder="Password"
                />
              </Form.Item>

              <Form.Item
                name={"confirm_password"}
                className="mt-4"
                labelCol={{ span: 24 }}
                dependencies={["password"]}
                rules={[
                  {
                    required: true,
                    message: "Please confirm your password",
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("Passwords do not match")
                      );
                    },
                  }),
                ]}
              >
                <Input.Password
                  prefix={
                    <BiLockAlt className="text-gray-400 font-bold text-2xl" />
                  }
                  className="custom-placeholder bg-black text-white hover:bg-black shadow-sm shadow-[#a6a6a6] rounded-2xl border-none"
                  placeholder="Confirm Password"
                />
              </Form.Item>

              <Form.Item className="text-center">
                <Button
                  loading={loading}
                  htmlType="submit"
                  className="w-3/4 custome rounded-3xl h-10 font-medium text-lg border-none
                   text-white bg-gradient-to-r from-[#734e0c] via-[#ba7d13] to-[#e9a52f]
                   hover:bg-gradient-to-r hover:from-[#734e0c] hover:via-[#ba7d13] hover:to-[#e9a52f]"
                >
                  Create Account
                </Button>
              </Form.Item>
            </Form>

            <NavLink to={"/"}>
              <p className="m-0 text-center custome text-sm text-white cursor-pointer">
                Already have an account?{" "}
                <span className="text-yellow-300 font-semibold">Login</span>
              </p>
            </NavLink>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Registration;
